var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"map-view"},[_c('surface',{attrs:{"asset-id":_vm.asset}}),_c('sidebar')],1):_c('loader')}
var staticRenderFns = []

export { render, staticRenderFns }